/**
 * Convert a string to Capitalized Words
 * @param {String} str - The string to be converted
 * @returns {String} - The converted string with each word capitalized
 *
 * Example:
 * capitalizeWords('hello world') // returns 'Hello World'
 * capitalizeWords('this is a test') // returns 'This Is A Test'
 */
export function capitalizeWords(str) {
    if (typeof str !== 'string') return str;

    return str
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

/**
 * Formats a US phone number string into NXX-NXX-XXXX (e.g. "973-971-7165").
 *
 * Accepts any mix of digits, hyphens, spaces, dots, and parentheses. Strips
 * all non-digit characters before classifying:
 *   - 10 digits → NXX-NXX-XXXX
 *   - 11 digits starting with "1" → strips country code, then NXX-NXX-XXXX
 *   - Any other digit count → returns the original input unchanged
 *
 * @param {*} phone - Raw phone value from the API or CMS.
 * @returns {string} Formatted phone string, empty string for null/undefined/empty input.
 *
 * Examples:
 *   formatPhoneNumber('8624150509')    → '862-415-0509'
 *   formatPhoneNumber('18624150509')   → '862-415-0509'
 *   formatPhoneNumber('973-971-7165')  → '973-971-7165'  (already formatted)
 *   formatPhoneNumber('(973) 971-7165') → '973-971-7165' (normalized)
 *   formatPhoneNumber(null)            → ''
 *   formatPhoneNumber('')              → ''
 *   formatPhoneNumber('12345')         → '12345'         (unrecognized — pass-through)
 */
export function formatPhoneNumber(phone) {
    if (typeof phone !== 'string' || !phone.trim()) return '';

    const digits = phone.replace(/\D/g, '');

    if (digits.length === 11 && digits[0] === '1') {
        const local = digits.slice(1);
        return `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6)}`;
    }

    if (digits.length === 10) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }

    return phone;
}
